export var TripCategoryEnum;
(function (TripCategoryEnum) {
    TripCategoryEnum["OneWay"] = "OneWay";
    TripCategoryEnum["RoundTrip"] = "RoundTrip";
    TripCategoryEnum["MultiCity"] = "MultiCity";
})(TripCategoryEnum || (TripCategoryEnum = {}));
//# sourceMappingURL=cross-sell.js.map